/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MaintenanceTicketSummaryDto } from './MaintenanceTicketSummaryDto';
import {
    MaintenanceTicketSummaryDtoFromJSON,
    MaintenanceTicketSummaryDtoFromJSONTyped,
    MaintenanceTicketSummaryDtoToJSON,
    MaintenanceTicketSummaryDtoToJSONTyped,
} from './MaintenanceTicketSummaryDto';

/**
 * 
 * @export
 * @interface CompleteWorkOrderResponseDto
 */
export interface CompleteWorkOrderResponseDto {
    /**
     * 
     * @type {Array<MaintenanceTicketSummaryDto>}
     * @memberof CompleteWorkOrderResponseDto
     */
    tickets: Array<MaintenanceTicketSummaryDto>;
}

/**
 * Check if a given object implements the CompleteWorkOrderResponseDto interface.
 */
export function instanceOfCompleteWorkOrderResponseDto(value: object): value is CompleteWorkOrderResponseDto {
    if (!('tickets' in value) || value['tickets'] === undefined) return false;
    return true;
}

export function CompleteWorkOrderResponseDtoFromJSON(json: any): CompleteWorkOrderResponseDto {
    return CompleteWorkOrderResponseDtoFromJSONTyped(json, false);
}

export function CompleteWorkOrderResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteWorkOrderResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tickets': ((json['tickets'] as Array<any>).map(MaintenanceTicketSummaryDtoFromJSON)),
    };
}

export function CompleteWorkOrderResponseDtoToJSON(json: any): CompleteWorkOrderResponseDto {
    return CompleteWorkOrderResponseDtoToJSONTyped(json, false);
}

export function CompleteWorkOrderResponseDtoToJSONTyped(value?: CompleteWorkOrderResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tickets': ((value['tickets'] as Array<any>).map(MaintenanceTicketSummaryDtoToJSON)),
    };
}

